import { render } from "./index.vue?vue&type=template&id=a4e8fc18&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=a4e8fc18&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4e8fc18"],['__file',"src/views/ticket/tag/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a4e8fc18"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a4e8fc18', __exports__)) {
    console.log('reload')
    api.reload('a4e8fc18', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=a4e8fc18&scoped=true", () => {
    console.log('re-render')
    api.rerender('a4e8fc18', render)
  })

}


export default __exports__